import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SessionService } from '../../store/services/session.service';

@Injectable()
export class ApiKeysFeatureGuard implements CanActivate {
  constructor(
    private readonly sessionService: SessionService,
    private readonly router: Router,
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.sessionService.onReady().pipe(
      filter(session => !!session),
      map(session =>
        session.api_keys_feature_enabled
          ? true
          : this.router.createUrlTree(['/']),
      ),
    );
  }
}
